// Copied from Endisys
function wrapTextInSup(targetString: string, className: string): void {
	const nodeIterator: NodeIterator = document.createNodeIterator(
		document.body,
		NodeFilter.SHOW_TEXT,
		null
	);

	const lowerCaseTargetString: string = targetString.toLowerCase();

	let currentNode: Text | null;
	while (currentNode = nodeIterator.nextNode() as Text) {
		const parentNode: HTMLElement | null = currentNode.parentElement;
		const lowerCaseNodeValue: string = currentNode.nodeValue?.toLowerCase() || '';

		// Check if the parent is an <sup> tag and contains the target string (case-insensitive)
		if (parentNode && parentNode.tagName === 'SUP' && lowerCaseNodeValue.trim() === lowerCaseTargetString) {
			parentNode.classList.add(className);
			continue;
		}

		// If the node contains the target string (case-insensitive), but is not already wrapped in <sup>
		if (lowerCaseNodeValue.includes(lowerCaseTargetString)) {
			const regex = new RegExp(`(${targetString})(\\s*)`, 'gi');
			const fragment: DocumentFragment = document.createDocumentFragment();

			// Replace matched text with <sup> element, preserving trailing spaces
			currentNode.nodeValue?.split(regex).forEach((part, index) => {
				if (part.toLowerCase() === lowerCaseTargetString) {
					const sup: HTMLElement = document.createElement('sup');
					sup.textContent = part;
					sup.classList.add(className);
					fragment.appendChild(sup);
				} else {
					fragment.appendChild(document.createTextNode(part));
				}
			});

			parentNode?.replaceChild(fragment, currentNode);
		}
	}
}

wrapTextInSup('®', 'registered-trademark');